import { useEffect } from 'react';
import { useGlobal } from 'context/GlobalContext';
import TasksViewShell from '../TasksViewShell';
import TaskCalendar from './TaskCalendar';
import TaskCalendarLegend from './TaskCalendarLegend';

const Calendar = () => {
    const { g } = useGlobal();
    const { setFooterComponent } = g;

    useEffect(() => {
        setFooterComponent(<TaskCalendarLegend />);
        return () => setFooterComponent(null);
    }, [setFooterComponent]);

    return (
        <TasksViewShell contentClassName="task-board-page__calendar">
            <TaskCalendar />
        </TasksViewShell>
    );
};

export default Calendar;
